module.exports = __webpack_public_path__ + "media/images/shapes/shape-5-6e07de8dbae123bd72861d9da21c5e2b.svg";